import Loading from './index.vue'
var obj = {}

obj.install = function(Vue) {
  // 1.创建组件构造器
  const LoadingConstructor = Vue.extend(Loading)
  // 2.new方式通过构造器创建一个组件对象
  const newLoading = new LoadingConstructor()
  // 3.将组件对象挂载到div上
  newLoading.$mount(document.createElement('div'))
  // 4.插入body中
  document.body.appendChild(newLoading.$el)
  Vue.prototype.$loading = newLoading
}
export default obj
